function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#484848",
  fillRule: "nonzero",
  stroke: "#484848",
  strokeWidth: 0.3
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 4.444h-2v-1.11a1.333 1.333 0 0 0-2.667 0v1.11H8.667v-1.11a1.333 1.333 0 0 0-2.667 0v1.11H4a2.002 2.002 0 0 0-2 2V20a2.002 2.002 0 0 0 2 2h16a2.002 2.002 0 0 0 2-2V6.444a2.002 2.002 0 0 0-2-2zm-3.778-1.11a.444.444 0 0 1 .89 0v2.444a.444.444 0 1 1-.89 0V3.333zm-9.333 0a.444.444 0 1 1 .889 0v2.444a.444.444 0 0 1-.89 0V3.333zM4 5.333h2v.444a1.333 1.333 0 0 0 2.667 0v-.445h6.666v.445a1.333 1.333 0 0 0 2.667 0v-.445h2c.613.001 1.11.498 1.111 1.111v2H2.89v-2c0-.613.498-1.11 1.111-1.11zM20 21.11H4c-.613 0-1.11-.498-1.111-1.111V9.333H21.11V20c0 .613-.498 1.11-1.111 1.111z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.075 11.853l-5.797 5.796-3.02-3.019a.444.444 0 0 0-.628.629l3.334 3.333a.444.444 0 0 0 .628 0l6.111-6.11a.444.444 0 1 0-.628-.63z"
}));

var SvgRezervation = function SvgRezervation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRezervation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rezervation.af560b2f.svg";
export { ForwardRef as ReactComponent };